import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { Member } from '@gem/call/CallStore/Member/Member';
import { CallMemberStatus } from '@gem/call/Model/callModel.types';

interface ICallMemberPresenter {
  member: Member | null;
  userId: string;
  memberState: CallMemberStatus;
}

export const useCallMemberPresenter = (userId: string, call: Call): ICallMemberPresenter => {
  const presenter = useLocalObservable<ICallMemberPresenter>(() => ({
    userId: userId,

    get member(): Member | null {
      return call.members.getMemberById(userId) || null;
    },

    get memberState(): CallMemberStatus {
      return presenter.member?.devicesList.some(
        (memberDevice) => memberDevice.state === CallMemberStatus.OnCall
      )
        ? CallMemberStatus.OnCall
        : CallMemberStatus.NotOnCall;
    },
  }));

  useEffect(() => {
    presenter.userId = userId;
  }, [userId]);

  return presenter;
};
